(function ($) {
  var $ = jQuery = $;

  class AnnouncementSlider {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(
      container.querySelectorAll("[data-announcement-slide]")
    );

    this.currentIndex = 0;
    this.interval = null;
    this.autoplaySpeed =
      parseInt(container.dataset.autoplaySpeed, 10) || 5000;

    if (this.slides.length < 2) return;

    this.startAutoplay();

    this.container.addEventListener("mouseenter", () => {
      this.stopAutoplay();
    });

    this.container.addEventListener("mouseleave", () => {
      this.startAutoplay();
    });

    this.container.addEventListener("focusin", () => {
      this.stopAutoplay();
    });

    this.container.addEventListener("focusout", () => {
      this.startAutoplay();
    });
  }

  showSlide(index) {
    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;

      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    this.currentIndex = index;
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  startAutoplay() {
    this.stopAutoplay();

    this.interval = window.setInterval(() => {
      this.nextSlide();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }
}

function initializeAnnouncementSliders(container = document) {
  container
    .querySelectorAll("[data-announcement-slider]")
    .forEach((slider) => {
      if (slider.dataset.initialized === "true") return;

      slider.dataset.initialized = "true";
      new AnnouncementSlider(slider);
    });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeAnnouncementSliders();
});

document.addEventListener("shopify:section:load", (event) => {
  initializeAnnouncementSliders(event.target);
});

})(theme.jQuery);  

